class jb_discount_stage_email extends HTMLElement {
  constructor() {
    super();

    this.currentStage = 0;
    this.brandValue = "";
    this.sizeValue = "";
    this.assignedOffer = null;

    this.offers = [];
    this.fakeActivity = [];
    this.products = [];

    this.currency = "USD";
    this.realCheckout = false;
    this.redirectUrl = "/collections/all";

    this.activityIndex = 0;
    this.activityInterval = null;
    this.timeouts = [];
  }

  connectedCallback() {
    this.loadConfig();
    this.cacheElements();
    this.bindEvents();
    this.initializeActivityFeed();
  }

  disconnectedCallback() {
    if (this.activityInterval) {
      clearInterval(this.activityInterval);
      this.activityInterval = null;
    }

    this.clearTimeouts();
  }

  loadConfig() {
    this.currency = this.dataset.currency || "USD";
    this.realCheckout = this.dataset.realCheckout === "true";
    this.redirectUrl = this.dataset.redirectUrl || "/collections/all";

    const configId = this.dataset.configId;
    const configScript = configId ? document.getElementById(configId) : null;

    if (!configScript) return;

    try {
      const config = JSON.parse(configScript.textContent);
      this.offers = Array.isArray(config.offers) ? config.offers : [];
      this.fakeActivity = Array.isArray(config.activity) ? config.activity : [];
      this.products = Array.isArray(config.products) ? config.products : [];
    } catch (error) {
      console.error("jb-discount-stage: failed to parse config", error);
    }
  }

  clearTimeouts() {
    this.timeouts.forEach((timeout) => clearTimeout(timeout));
    this.timeouts = [];
  }

  addTimeout(callback, delay) {
    const timeout = setTimeout(() => {
      callback();
      this.timeouts = this.timeouts.filter((t) => t !== timeout);
    }, delay);
    this.timeouts.push(timeout);
    return timeout;
  }

  cacheElements() {
    this.phoneElement = this.querySelector("#jb_phone");
    this.backButton = this.querySelector("#jb_back");
    this.stages = [...this.querySelectorAll(".jb_stage")];
    this.progressBars = [...this.querySelectorAll(".jb_progress_item")];
    this.progressLabel = this.querySelector("#jb_progress_label");

    this.startButton = this.querySelector("#jb_start");
    this.brandInput = this.querySelector("#jb_brand");
    this.sizeSelect = this.querySelector("#jb_size");
    this.valueButton = this.querySelector("#jb_value");
    this.pvBrand = this.querySelector("#jb_pv_brand");
    this.pvSize = this.querySelector("#jb_pv_size");

    this.scanner = this.querySelector("#jb_scanner");
    this.scanLabel = this.querySelector("#jb_scan_label");

    this.reward = this.querySelector("#jb_reward");
    this.rule = this.querySelector("#jb_rule");
    this.outBrand = this.querySelector("#jb_out_brand");
    this.code = this.querySelector("#jb_code");
    this.emailInput = this.querySelector("#jb_email");
    this.continueButton = this.querySelector("#jb_continue");

    this.floatLabel = this.querySelector("#jb_float_label");
    this.floatValue = this.querySelector("#jb_float_value");
    this.priceElements = [...this.querySelectorAll("[data-jb-price]")];
    this.checkoutDemoButton = this.querySelector("#jb_checkout_demo");
    this.ctaCode = this.querySelector("#jb_cta_code");

    this.receiptLabel = this.querySelector("#jb_receipt_label");
    this.receiptCode = this.querySelector("#jb_receipt_code");
    this.receiptValue = this.querySelector("#jb_receipt_value");

    this.toast1 = this.querySelector("#jb_toast1");

    this.checkIds = ["jb_chk1", "jb_chk2", "jb_chk3", "jb_chk4"];
  }

  bindEvents() {
    if (this.backButton) {
      this.backButton.addEventListener("click", this.handleBack.bind(this));
    }

    if (this.startButton) {
      this.startButton.addEventListener("click", this.handleStart.bind(this));
    }

    if (this.brandInput) {
      this.brandInput.addEventListener(
        "input",
        this.updateLabelPreview.bind(this)
      );
    }

    if (this.sizeSelect) {
      this.sizeSelect.addEventListener(
        "change",
        this.updateLabelPreview.bind(this)
      );
    }

    if (this.valueButton) {
      this.valueButton.addEventListener(
        "click",
        this.handleValueClick.bind(this)
      );
    }

    if (this.continueButton) {
      this.continueButton.addEventListener(
        "click",
        this.handleContinue.bind(this)
      );
    }

    if (this.checkoutDemoButton) {
      this.checkoutDemoButton.addEventListener(
        "click",
        this.handleCheckout.bind(this)
      );
    }
  }

  showStage(index) {
    this.stages.forEach((stage, i) => {
      stage.classList.toggle("jb_active", i === index);
    });

    this.currentStage = index;

    if (this.backButton) {
      this.backButton.classList.toggle("jb_hidden", index === 0);
    }

    if (this.progressLabel) {
      this.progressLabel.textContent = `${String(index + 1).padStart(
        2,
        "0"
      )} / 06`;
    }

    this.progressBars.forEach((bar, i) => {
      bar.classList.toggle("jb_active", i <= index);
    });

    const targetElement = this.phoneElement || this;
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }

  handleBack() {
    if (this.currentStage === 0) return;

    if (this.currentStage === 2) {
      this.clearTimeouts();
      if (this.scanner) {
        this.scanner.classList.remove("jb_flash");
      }
      this.showStage(1);
      return;
    }

    if (this.currentStage === 3) {
      this.showStage(1);
      return;
    }

    this.showStage(this.currentStage - 1);
  }

  handleStart() {
    this.showStage(1);
  }

  updateLabelPreview() {
    this.brandValue = this.brandInput
      ? this.brandInput.value.trim().toUpperCase()
      : "";

    this.sizeValue = this.sizeSelect ? this.sizeSelect.value : "";

    if (this.pvBrand) {
      this.pvBrand.textContent = this.brandValue || "YOUR LABEL";
    }

    if (this.pvSize) {
      this.pvSize.textContent = this.sizeValue
        ? `SIZE ${this.sizeValue}`
        : "SIZE —";
    }

    if (this.valueButton) {
      this.valueButton.disabled = !(this.brandValue && this.sizeValue);
    }
  }

  hashString(str) {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash = hash | 0;
    }

    return Math.abs(hash);
  }

  assignOffer() {
    if (!this.offers.length) {
      this.assignedOffer = null;
      return;
    }

    const offerIndex =
      this.hashString(`${this.brandValue}|${this.sizeValue}`) %
      this.offers.length;

    this.assignedOffer = this.offers[offerIndex];
  }

  handleValueClick() {
    this.assignOffer();
    this.startScanner();
  }

  startScanner() {
    this.clearTimeouts();

    if (this.scanLabel) {
      this.scanLabel.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    this.showStage(2);

    this.checkIds.forEach((id) => {
      const element = this.querySelector(`#${id}`);
      if (element) {
        const text = element.textContent.trim().replace("[✓]", "[ ]");
        element.textContent = text;
      }
    });

    this.checkIds.forEach((id, index) => {
      this.addTimeout(() => {
        const element = this.querySelector(`#${id}`);
        if (element) {
          element.textContent = element.textContent.replace("[ ]", "[✓]");
          element.classList.add("jb_text_red");
        }
      }, 430 + index * 420);
    });

    this.addTimeout(() => {
      if (this.scanner) {
        this.scanner.classList.add("jb_flash");
      }

      this.addTimeout(() => {
        if (this.scanner) {
          this.scanner.classList.remove("jb_flash");
        }

        this.updateRewardUI();
        this.showStage(3);
      }, 380);
    }, 2300);
  }

  updateRewardUI() {
    if (!this.assignedOffer) return;

    if (this.reward) {
      this.reward.textContent = this.assignedOffer.label;
    }

    if (this.rule) {
      this.rule.textContent = this.assignedOffer.rule;
    }

    if (this.outBrand) {
      this.outBrand.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    if (this.code) {
      this.code.textContent = this.assignedOffer.code;
    }

    if (this.floatLabel) {
      this.floatLabel.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    if (this.floatValue) {
      this.floatValue.textContent = `-${this.assignedOffer.label}`;
    }

    if (this.ctaCode) {
      this.ctaCode.textContent = this.assignedOffer.code;
    }

    if (this.receiptLabel) {
      this.receiptLabel.textContent = `${this.brandValue} / ${this.sizeValue}`;
    }

    if (this.receiptCode) {
      this.receiptCode.textContent = this.assignedOffer.code;
    }

    if (this.receiptValue) {
      this.receiptValue.textContent = `PAID ${this.assignedOffer.label}`;
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: this.currency,
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  }

  // Discounted price in cents for a given product (price is already in cents).
  calculatePriceCents(priceCents) {
    if (!this.assignedOffer) return priceCents;

    if (this.assignedOffer.amount_type === "percentage") {
      const fraction = this.assignedOffer.amount / 100;
      return Math.round(priceCents * (1 - fraction));
    }

    const discountCents = Math.round(this.assignedOffer.amount * 100);
    return Math.max(0, priceCents - discountCents);
  }

  handleContinue() {
    if (this.emailInput) {
      if (!this.emailInput.reportValidity()) {
        return;
      }

      const email = this.emailInput.value.trim();
      console.log("jb-discount-stage: captured email", email);
    }

    this.priceElements.forEach((element) => {
      const index = Number(element.closest("[data-jb-product-index]")?.dataset.jbProductIndex);
      const product = this.products[index];

      if (!product) return;

      const discountedCents = this.calculatePriceCents(product.price);
      element.textContent = this.formatMoney(discountedCents);
    });

    this.showStage(4);
  }

  handleCheckout() {
    if (this.realCheckout && this.assignedOffer) {
      const code = encodeURIComponent(this.assignedOffer.code);
      const redirect = encodeURIComponent(this.redirectUrl);
      window.location.href = `/discount/${code}?redirect=${redirect}`;
      return;
    }

    this.showStage(5);
  }

  initializeActivityFeed() {
    if (!this.fakeActivity.length) return;

    if (this.activityInterval) {
      clearInterval(this.activityInterval);
    }

    this.activityInterval = setInterval(() => {
      if (this.currentStage !== 0) {
        return;
      }

      this.activityIndex =
        (this.activityIndex + 1) % this.fakeActivity.length;

      const activity = this.fakeActivity[this.activityIndex];

      if (this.toast1) {
        this.toast1.style.animation = "none";

        void this.toast1.offsetWidth;

        this.toast1.innerHTML = `
          <div class="jb_activity_label jb_mono">
            <span class="jb_pulse_dot"></span>
            Simulated exchange activity
          </div>

          <div class="jb_activity_text">
            <span class="jb_text_red">
              ${activity.name}
              exchanged
              ${activity.label}.
            </span>

            <br />

            ${activity.message}
          </div>
        `;

        this.toast1.style.animation =
          "jb_toastIn 0.45s cubic-bezier(0.16, 1, 0.3, 1)";
      }
    }, 3300);
  }
}

if (!customElements.get("jb-discount-stage-email")) {
  customElements.define("jb-discount-stage-email", jb_discount_stage_email);
}
